import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const urineAbnormalities: AnswerPathTreeNode = {
  path: 'urineAbnormalities',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredUrineAbnormalitiesDetails }],
};
